import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { branch } from 'baobab-react/higher-order';
import request from 'superagent';
import tree from '../../../state';
import Header from '../../common/Header';
import SupportNav from '.././SupportNav';
import TrackedLink from "../../common/TrackedLink";

const Recaptcha = require('react-recaptcha');
let recaptchaInstance = null;

const callback = () => {
	// console.log('Done!!!!');
};

const verifyCallback = response => {
	// console.log(response);
	if (response !== 0 && response !== null) {
		recaptchaInstance = 'verified';
	}
};


class ContactUsUSACanada extends Component {
	constructor(props) {
		super(props);
		this.state = {
			flag: true
		};

		this.handleChange = this.handleChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	onSubmit(e) {
		e.preventDefault();
		if (recaptchaInstance === null) {
			alert('Please verify you are not a robot.');
		} else {
			const formPayload = {
				firstName: this.refs.firstName.value,
				lastName: this.refs.lastName.value,
				address: this.refs.address.value,
				address2: this.refs.address2.value,
				city: this.refs.city.value,
				stateProvince: this.stateProvince.value,
				zip: this.refs.zip.value.toUpperCase(),
				phoneNumber: this.refs.phoneNumber.value,
				emailaddress: this.refs.emailaddress.value,
				confirmemail: this.refs.confirmemail.value,
				modelnumber: this.refs.modelnumber.value,
				serialnumber: this.refs.serialnumber.value,
				comments: this.refs.comments.value,
				promotionResponse: document.querySelector('input[name = "promotionresponse"]:checked') ? "yes" : "no"
			};

			this.checkConfirmEmail(formPayload.emailaddress, formPayload.confirmemail);

			if (this.state.flag) {
				request.post('/api/support/contactusamerica')
					.send(formPayload)
					.set('authorization', tree.get('token'))
					.type('json')
					.end(function (res) {
						// console.log(res);
						window.location = 'thankyou';
					});
			}
		}
	}

	handleChange(event) {
		this.setState({ [event.target.refs]: event.target.value });
	}

	checkConfirmEmail(email, confirmEmail) {
		if (email !== confirmEmail) {
			alert('email and confirm email should match');
			this.setState({ flag: false });
		} else {
			this.setState({ flag: true });
		}
	}

	render() {
		const stateList = this.props.stateProvince;
		var MaskedInput = require('./MaskedInput.js');
		let stateOptions;
		if (stateList != null) {
			stateOptions = (
				stateList.map((item, index) => <option key={index} value={item.key}>{item.value}</option>)
			);
		}

		return (
			<div className="contact-us">
				<Helmet>
					<title>Contact SentrySafe &#124; US &amp; Canada &#124; SentrySafe</title>
					<meta name="description" content="The SentrySafe United States and Canada Customer Care Team is dedicated to providing timely and exceptional service and support to our customers. Contact Us Now." />
					<script id="RightNowScript" src="//masterlock.widget.custhelp.com/euf/rightnow/RightNow.Client.js" />
					<script innerHTML={`
						document.getElementById('RightNowScript').addEventListener('load', function() {
							if (window.RightNow) {
								window.RightNow.Client.Controller.addComponent({
									chat_login_page: '/app/chat/chat_launch/brand/sentrysafe',
									ignore_preroute: true,
									container_element_id: 'myChatLinkContainer',
									custom_fields: '{"92":"387"}',
									info_element_id: 'myChatLinkInfo',
									link_element_id: 'myChatLink',
									label_available_immediately_template: 'Chat Live',
									label_available_with_wait_template: 'Chat Live.',
									label_default: 'Chat Live',
									label_unavailable_busy_template: 'Chat is offline',
									wait_threshold: 120,instance_id: 'sccl_0',
									module: 'ConditionalChatLink',
									type: 7
								}, '//masterlock.widget.custhelp.com/ci/ws/get');
							}
						});
					`} />
				</Helmet>

				<SupportNav />

				<Header
					title="Contact Us"
					description="Thank you for contacting us. Please send us an email by filling out the form below."
				/>

				<div className="row">
					<div className="col sm-7 contactUsForm">
						<form onSubmit={e => this.onSubmit(e)}>
							<div className="form-group col sm-12">
								<p className="required-text">&#40;&#42;&#41; Indicates a required field</p>
								<h3>Your Personal Information&#58;</h3>
							</div>
							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="FirstName">First Name</label>
								<input type="text" id="FirstName" ref="firstName" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="LastName">Last Name</label>
								<input type="text" id="LastName" ref="lastName" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="Address1">Address Line 1</label>
								<input type="text" id="Address1" ref="address" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="Address2">Address Line 2</label>
								<input type="text" id="Address2" ref="address2" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="City">City</label>
								<input type="text" id="City" ref="city" required="required" />
							</div>

							<div className="form-group col sm-3">
								<label className="required-field-label" htmlFor="stateProvince">
									State&#47;Province
								</label>
								<select
									id="stateProvince"
									ref={input => this.stateProvince = input}
									required="required"
								>
									<option value="" disabled selected>&#45; Select State &#45;</option>
									{stateOptions}
								</select>
							</div>

							<div className="form-group col sm-3">
								<label className="required-field-label" htmlFor="Zip">Zip&#47;Postal Code</label>
								<input type="text" id="Zip" pattern="(^\d{5}(-\d{4})?$)|(^[abceghjkmnprstvxyABCEGHJKLMNPRSTVXY]{1}\d{1}[a-zA-Z]{1} *\d{1}[a-zA-Z]{1}\d{1}$)" title="Please use either 5 digits for US postal codes, or 6 letters and digits for CAN" ref="zip" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="Email">Email</label>
								<input type="email" id="Email" ref="emailaddress" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="ConfirmEmail">Confirm Email</label>
								<input type="email" id="ConfirmEmail" ref="confirmemail" required="required" />
							</div>

							<div className="form-group col sm-6">
								<label className="required-field-label" htmlFor="Phone">Phone Number</label>
								<MaskedInput
									id="Phone"
									ref="phoneNumber"
									type="tel"
									placeholder="(XXX) XXX-XXXX"
									pattern="\([0-9]{3}\)\s[0-9]{3}-[0-9]{4}"
									required="required"
									title="Full 10-digit phone number" />
							</div>

							<div className="form-group col sm-7">
								<h3>Your Safe&rsquo;s Information&#58;</h3>
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="SafeModel">Your Safe&rsquo;s Model &#35;</label>
								<input type="text" id="SafeModel" ref="modelnumber" />
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="SafeSerial">Your Safe&rsquo;s Serial &#35;</label>
								<input type="text" id="SafeSerial" ref="serialnumber" />
							</div>

							<div className="form-group col sm-12">
								<TrackedLink to="/support/find-your-model-or-serial-number" target="_blank">
									Where do I get this information&#63;
								</TrackedLink>
							</div>

							<div className="form-group col sm-6">
								<label htmlFor="Comments">
									Please tell us why you&rsquo;re contacting us&#58;
								</label>
								<textarea id="Comments" ref="comments" />
							</div>

							<div className="form-group col sm-6 promo">
								<label htmlFor="promotionYes">
									Receive product tips, updates, and offers sent to your inbox from SentrySafe.  You can opt out at any time. <TrackedLink to="https://www.masterlock.com/privacy-policy?elqTrackId=291089b5445b47c1b39505c225f8cee9&elqaid=119&elqat=2" target="_blank">Privacy Policy</TrackedLink>
								</label>
								<input type="checkbox"
									name="promotionresponse"
									id="promotionYes"
									value="yes" />
							</div>

							<div className="form-group col sm-6">
								<Recaptcha
									sitekey="6LeNsjUUAAAAAM4fkzXrDfqUOXQIRzSi3vRAHh8B"
									render="explicit"
									onloadCallback={callback}
									verifyCallback={verifyCallback}
								/>
								<button className="btn btn-primary" type="submit">
									Send Email
								</button>
							</div>
						</form>
					</div>
					<div className="col sm-4 reach-us">
						<p>Please either call us or submit the form on this page.</p>
						<dl>
							<dd>
								Call the SentrySafe Customer Care Line: <TrackedLink to="tel:8008281438">1-800-828-1438</TrackedLink>
							</dd>
							<dd>
								Office Hours: <span>Monday &ndash; Friday, 8:30 AM &ndash; 5:00 PM CST</span>
							</dd>
						</dl>
					</div>
				</div>
			</div>
		);
	}
};

export default branch({
	stateProvince: ['support', 'stateProvince'],
	reasons: ['support', 'reasons'],
}, ContactUsUSACanada);



// WEBPACK FOOTER //
// ./src/pages/support/contactUs/ContactUsUSACanada.js